import {Paper} from '@mantine/core';

export const PaperTheme = Paper.extend({
  defaultProps: {
    shadow: 'xs',
    withBorder: true,
  },
});